"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @trackcomponent */
export const SocialFacebook = createSVGIcon(
  <>
    <path
      d="M13.7139 6.85713C13.7139 5.14285 14.571 5.14285 15.4282 5.14285H16.4567C16.6285 5.14515 16.7989 5.11303 16.958 5.04837C17.1171 4.98371 17.2617 4.88783 17.3831 4.76639C17.5046 4.64494 17.6005 4.5004 17.6651 4.34129C17.7298 4.18218 17.7619 4.01172 17.7596 3.83999V2.22856C17.7596 2.05602 17.7253 1.88519 17.6588 1.72599C17.5923 1.56679 17.4948 1.4224 17.3719 1.30119C17.2491 1.17998 17.1035 1.08437 16.9434 1.01992C16.7834 0.955458 16.6121 0.923435 16.4396 0.925706L14.0053 0.89142C13.2965 0.864004 12.5902 0.990717 11.9351 1.26281C11.28 1.53491 10.6918 1.94591 10.211 2.46744C9.73022 2.98898 9.36832 3.60863 9.1503 4.28363C8.93227 4.95862 8.8633 5.67289 8.94816 6.37713V8.86285H7.59387C7.24833 8.86285 6.91695 9.00011 6.67261 9.24445C6.42828 9.48878 6.29102 9.82017 6.29102 10.1657V11.7771C6.29102 12.1227 6.42828 12.4541 6.67261 12.6984C6.91695 12.9427 7.24833 13.08 7.59387 13.08H8.94816V22.2857C8.94816 22.513 9.03846 22.7311 9.19921 22.8918C9.35995 23.0525 9.57797 23.1428 9.8053 23.1428H12.9082C13.1265 23.1297 13.3315 23.0337 13.4813 22.8743C13.6311 22.715 13.7143 22.5044 13.7139 22.2857V13.08H15.2224C15.568 13.08 15.8994 12.9427 16.1437 12.6984C16.388 12.4541 16.5253 12.1227 16.5253 11.7771V10.1657C16.5253 9.82017 16.388 9.48878 16.1437 9.24445C15.8994 9.00011 15.568 8.86285 15.2224 8.86285H13.7139V6.85713Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SocialFacebook",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Facebook",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
